import {CustomerDetailError} from '@/lib/customer-detail-error';
import { useParams } from 'react-router-dom';
import { CustomerDetailBase } from '@/components/app-hostesses/customers/shared/customer-detail-base';
import { useCustomerDetail } from '@/hooks/useCustomerDetail';

/**
 * 顧客詳細ページ
 *
 * URL の id から顧客を特定し、RPC 戻り値の visible_customer_category を
 * 信頼してカテゴリ表示を決定する。URL クエリ ?type= や location.state は
 * 使用しない (旧仕様の誤表示要因だったため撤廃)。
 */
export default function CustomerDetail() {
  const { id } = useParams<{ id: string }>();
  const { data: customerData, isLoading, error } = useCustomerDetail(id);

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-center">
          <div className="mx-auto mb-4 h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
          <p className="text-sm text-gray-500">読み込み中...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-center">
          <p className="text-lg text-red-500">エラーが発生しました</p>
          <p className="mt-2 text-sm text-gray-500">{error instanceof CustomerDetailError && error.kind === "forbidden" ? "このお客様は担当外のため表示できません" : error.message}</p>
        </div>
      </div>
    );
  }

  if (!customerData) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-center">
          <p className="text-lg">顧客が見つかりません</p>
          <p className="mt-2 text-sm text-gray-500">ID: {id}</p>
        </div>
      </div>
    );
  }

  return <CustomerDetailBase data={customerData} />;
}
